var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "300", persistent: true },
      model: {
        value: _vm.dialogIsOpen,
        callback: function($$v) {
          _vm.dialogIsOpen = $$v
        },
        expression: "dialogIsOpen"
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass:
            "dialog-box home-form-container building_structure_dialog"
        },
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("BuildingStructure")) + "\n    ")
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            {
              staticStyle: { "padding-bottom": "10px", "white-space": "normal" }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("DefineBuildingStructure")) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c("input-field", {
            attrs: {
              label: _vm.$t("GroundFloors"),
              size: "medium",
              "input-type": "int",
              min: "1",
              required: true
            },
            model: {
              value: _vm.nrGroundFloors,
              callback: function($$v) {
                _vm.nrGroundFloors = $$v
              },
              expression: "nrGroundFloors"
            }
          }),
          _vm._v(" "),
          _c("input-field", {
            attrs: {
              label: _vm.$t("UndergroundFloors"),
              size: "medium",
              "input-type": "int",
              min: "0",
              required: true
            },
            model: {
              value: _vm.nrUndergroundFloors,
              callback: function($$v) {
                _vm.nrUndergroundFloors = $$v
              },
              expression: "nrUndergroundFloors"
            }
          }),
          _vm._v(" "),
          _c("input-field", {
            attrs: {
              label: _vm.$tc("Fraction", 2),
              size: "medium",
              "input-type": "int",
              min: "1",
              required: true
            },
            model: {
              value: _vm.nrFractionsPerFloor,
              callback: function($$v) {
                _vm.nrFractionsPerFloor = $$v
              },
              expression: "nrFractionsPerFloor"
            }
          }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  staticClass: "secondary-button",
                  attrs: { ripple: false, text: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close-dialog")
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Cancel")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "main-button",
                  attrs: { ripple: false, text: "" },
                  on: {
                    click: function($event) {
                      _vm.$emit("preview-building", {
                        groundFloors: parseInt(_vm.nrGroundFloors),
                        undergroundFloors: parseInt(_vm.nrUndergroundFloors),
                        fractions: parseInt(_vm.nrFractionsPerFloor)
                      })
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Create")) + "\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55201095", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55201095","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/BuildingStructureDialog.vue
// module id = null
// module chunks = 